<template>
    <el-dialog
      title="Добавление иконки"
      :visible.sync="$store.getters.iconDialog"
      width="60%"
      :before-close="handleClose"
    >
      <el-form label-width="120px" name="uploadFormIcon">
          <el-form-item label="Текст">
              <el-input v-model="form.alt"></el-input>
          </el-form-item>
          <el-form-item label="Изображение">
          <el-upload
            action=""
            list-type="picture"
            :limit="1"
            :auto-upload="false"
            :on-change="handleChange"
            >
              <el-button size="small" type="primary">Добавить Изображение</el-button>
            </el-upload>
            </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="$store.commit('iconDialog',false)">Отмена</el-button>
        <el-button type="primary" :disabled="buttonDisable" @click="storeIcon">Добавить</el-button>
      </span>
    </el-dialog>
</template>

<script>
import axios from "axios";
import useFormData from '../../composable/useFormData'
import getErrors, { getTextErrors } from '../../composable/utils/getErrors';

export default {
name: "BannerCreate",
  data: function (){
    
    return {
      disableButton: true,
     form: {
        alt: '',
        icon: '',
      },

    }
  },

  computed: {
    buttonDisable() {
      return this.form.icon === '';
    }
  },

  methods:{   
    handleClose() {
      this.$store.commit('iconDialog',false);
    },
    handleChange(v){
      this.form.icon = v?.raw || undefined
    },
    async storeIcon() {
      const data = useFormData().execute().setFields([
        'alt',
        'icon',
      ]).getFormData(this.form)
      
      axios.post('icon',data)
      .then(()=>{                
        this.$store.dispatch("updateGeneralIcons");
      })
      .then(() => {
        this.handleClose();
      })
      .catch((errors)=>{

        if(errors.response?.status === 401){
          this.$router.push('/login');
        }

        if(errors.response?.status === 422) {
          this.setErrors(errors.response.data.errors)
        }
      });
    },
    setErrors(err) {
      const errors = getErrors(err)
      this.$notify.error(getTextErrors(errors))
    }
  }
}
</script>

<style>

</style>